import React,{useContext,useEffect} from 'react'
import {HeadTableLeads, RowLeadsseguimiento} from "../../ui-components";
import LeadsContext from '../../context/leads';


function FollowManager({onToggleTab,setAssignLead, order }) {
  const {LeadsAsign, models, Subs} = useContext(LeadsContext)

  useEffect(()=>{
    LeadsAsign(6, 9, order);
    Subs();
  },[order])

  return (
    <div className="overflow-x-scroll py-2">
    <HeadTableLeads type="followup"/>
    {models?.map((lead, index) => (
      index % 2 == 0 ?
      <RowLeadsseguimiento key={lead.id} leads={lead} overrides={{
        Button:{
          onClick: () =>{
            onToggleTab(6)
            setAssignLead(lead)
          }
        },
        Fase: {
          children: `${lead?.status  == 6 ? "Visita programada" : "Prospecto en proceso"}`
        }
      }}/> :
      <RowLeadsseguimiento key={lead.id} leads={lead} overrides={{
        "Frame 20797":{backgroundColor: "#ffffff"},
        Button:{
          onClick: () =>{
            onToggleTab(6)
            setAssignLead(lead)
          }
        },
        Fase: {
          children: `${lead?.status  == 6 ? "Visita programada" : "Prospecto en proceso"}`
        }
      }}/> 
    ))}
  </div>

  )
}
export default FollowManager